import { useEffect, useState } from "react";

import { useLayout } from "@/../_metronic/layout/core";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import Card from "react-bootstrap/Card";

import { Option } from "@/@types/generics/Option";

import { SelectComponent } from "@/components/SelectComponent";
import { DeadPatients } from "./DeadPatients";
import { DeadPatientsByPlace } from "./DeadPatientsByPlace";

export function GeneralDeaths() {
	const { setTitle } = useLayout();
	const [selectedReportOption, setSelectedReportOption] = useState<number | undefined>();

	const reportOptions: Option<number>[] = [
		{ label: "Óbitos por paciente", value: 1 },
		{ label: "Óbitos por local de ocorrência", value: 2 },
	];

	function renderReportComponent(reportOption?: number) {
		switch (reportOption) {
			case 1:
				return <DeadPatients />;
			case 2:
				return <DeadPatientsByPlace />;
		}
	}

	useEffect(() => {
		setTitle("Listagem - Óbitos");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="p-4">
			<Card className="h-100 shadow-sm">
				<Card.Body>
					<Row className="p-2">
						<Col>
							<InputGroup>
								<Form.Label>Tipo de relatório</Form.Label>
								<SelectComponent
									className="w-100"
									name="generaldeaths"
									options={reportOptions}
									onChange={(event) =>
										Boolean((event as Option<string>).value)
											? setSelectedReportOption(
													Number((event as Option<string>).value)
											  )
											: setSelectedReportOption(undefined)
									}
									defaultValue={{ value: "", label: "Escolha uma opção" }}
									noOptionsMessage={() =>
										"nenhum resultado encontrado na pesquisa"
									}
								/>
							</InputGroup>
						</Col>
					</Row>
					{renderReportComponent(selectedReportOption)}
				</Card.Body>
			</Card>
		</div>
	);
}
